// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7f999319","404":"5612c18a","465":"ecf406e4","498":"f9d98dab","513":"c6113601","787":"5bfea18a"}[chunkId] + ".chunk.js";
};